import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePwaInstall } from './usePwaInstall';
import { RaadLogo } from '@/components/RaadLogo';

/**
 * The install affordance (AC-1). Renders NOTHING until the browser has offered an
 * install (`beforeinstallprompt` captured) — never a dead control on a platform
 * that cannot install (CLAUDE.md — absence over disabled). Dismissible for the
 * session so it is a suggestion, not a nag.
 *
 * Tapping "Install" opens the browser's native install dialog; Mahad verifies the
 * dialog and the resulting home-screen icon on his phone (the automated suite
 * cannot fire a real `beforeinstallprompt`).
 */
export function InstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, promptInstall } = usePwaInstall();
  const [dismissed, setDismissed] = useState(false);

  if (!canInstall || dismissed) return null;

  return (
    <div className="flex items-center gap-3 border-b border-raad-border bg-raad-panel px-4 py-2.5 sm:px-6">
      <RaadLogo size={22} />
      <p className="min-w-0 flex-1 truncate text-[12.5px] text-raad-text">{t('install.prompt')}</p>
      <button
        type="button"
        onClick={() => void promptInstall()}
        className="min-h-9 flex-none rounded-lg bg-raad-primary px-3.5 text-[12.5px] font-semibold text-raad-onprimary transition-colors hover:bg-raad-accent"
      >
        {t('install.action')}
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label={t('install.dismiss')}
        className="flex size-8 flex-none items-center justify-center rounded-lg text-raad-muted hover:text-raad-text"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
